import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import InputLabel from '../../../../../../../components/v2/InputLabel';
import { DropdownGenerationConfig, TextGenerationConfig, GenerationConfigOptions } from '../constants';
import {
  ScrollableContainer,
  GridContainer,
  StyledSelect,
  TextField,
} from './styles';
import texts from './texts';

const GenerationConfigs = ({
  configs,
  setConfigs,
}) => {
  const handleOptionChange = useCallback((key, value) => {
    setConfigs((prev) => ({ ...prev, [key]: value }));
  }, [setConfigs]);

  return (
    <ScrollableContainer>
      <GridContainer $gridColumns={3}>
        {DropdownGenerationConfig.map((config) => (
          <StyledSelect
            key={config}
            label={texts.configLabels[config]}
            value={configs[config]}
            onChange={(e) => handleOptionChange(config, e.target.value)}
            options={GenerationConfigOptions[config]}
          />
        ))}
      </GridContainer>
      <GridContainer $gridColumns={1}>
        {TextGenerationConfig.map((config) => (
          <div key={config}>
            <InputLabel>{texts.configLabels[config]}</InputLabel>
            <TextField
              placeholder={texts.placeholders[config]}
              value={configs[config]}
              onChange={(e) => handleOptionChange(config, e.target.value)}
            />
          </div>
        ))}
      </GridContainer>
    </ScrollableContainer>
  );
};

GenerationConfigs.propTypes = {
  configs: PropTypes.object.isRequired,
  setConfigs: PropTypes.func.isRequired,
};

export default GenerationConfigs;
